import { IntlShape } from 'react-intl';

import { documentTypeMessages, type DocumentType } from '../config';

import { parseDocumentType } from './normalizeDocumentType';

const fallbackHumanize = (value: string): string =>
  value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getDocumentTypeLabel = (
  formatMessage: IntlShape['formatMessage'],
  type?: DocumentType | string | null,
): string => {
  if (!type) {
    return '—';
  }

  const normalizedType = parseDocumentType(type);

  if (!normalizedType) {
    return fallbackHumanize(String(type));
  }

  return formatMessage(documentTypeMessages[normalizedType]);
};
